import { Download, Description } from '@mui/icons-material';
import { Button, CardContainer } from 'finara-components';

interface BulkTemplateProps {
  onNext: () => void;
}

export const BulkTemplate: React.FC<BulkTemplateProps> = ({ onNext }) => {
  const handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = '/templates/plantilla_pagos_finara.csv';
    link.download = 'plantilla_pagos_finara.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-brand-white mb-2">Plantilla de Pagos</h2>
        <p className="text-muted">Descarga la plantilla Excel/CSV para estructurar tus pagos</p>
      </div>

      {/* Template Download Card */}
      <CardContainer className="p-8 text-center mb-8">
        <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <Description className="text-green-400" style={{ fontSize: '2.5rem' }} />
        </div>

        <h3 className="text-xl font-semibold text-brand-white mb-3">Plantilla Excel/CSV</h3>
        <p className="text-muted mb-6">
          Descarga la plantilla con las columnas requeridas para los pagos múltiples
        </p>

        <Button
          variant="black"
          size="large"
          startIcon={<Download />}
          onClick={handleDownloadTemplate}
          className="mb-6"
        >
          Descargar Plantilla
        </Button>
      </CardContainer>

      {/* Column Information */}
      <CardContainer className="p-6 mb-4">
        {/* Required Fields */}
        <div className="mb-6">
          <h5 className="text-xl font-semibold text-brand-white mb-3">Columnas Obligatorias</h5>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <div className="font-medium text-brand-white">nombre_beneficiario</div>
              <div className="text-md text-muted">Nombre completo del beneficiario</div>
            </div>

            <div>
              <div className="font-medium text-brand-white">clabe</div>
              <div className="text-md text-muted">CLABE interbancaria de 18 dígitos</div>
            </div>

            <div>
              <div className="font-medium text-brand-white">monto</div>
              <div className="text-md text-muted">
                Cantidad a transferir (usa . para decimales, ej: 1500.50)
              </div>
            </div>

            <div>
              <div className="font-medium text-brand-white">concepto</div>
              <div className="text-sm text-muted">Descripción o motivo del pago</div>
            </div>
          </div>
        </div>
      </CardContainer>
      <CardContainer className="p-6 mb-8">
        {/* Optional Fields */}
        <div className="mb-6">
          <h5 className="text-xl font-semibold text-brand-white mb-3">Columnas Opcionales</h5>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <div className="font-medium text-brand-white">email</div>
              <div className="text-md text-muted">Correo electrónico del beneficiario</div>
            </div>

            <div>
              <div className="font-medium text-brand-white">rfc</div>
              <div className="text-md text-muted">RFC del beneficiario (13 caracteres)</div>
            </div>

            <div className="md:col-span-2">
              <div className="font-medium text-brand-white">fecha</div>
              <div className="text-md text-muted">
                Fecha y hora para pagos programados (formato: YYYY-MM-DD HH:MM). Si se omite, el
                pago se procesa de inmediato.
              </div>
            </div>
          </div>
        </div>

        {/* Additional Notes */}
        <div className="mt-4 p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg">
          <p className="text-xs text-brand-white">
            <strong>Nota:</strong> Puedes dejar las columnas opcionales vacías, pero deben existir
            en el archivo CSV.
          </p>
        </div>
      </CardContainer>

      {/* Navigation */}
      <div className="flex justify-end">
        <Button variant="black" size="large" onClick={onNext} className="min-w-32">
          Siguiente
        </Button>
      </div>
    </div>
  );
};
